import { Stack, CheckboxContainer, Checkbox } from '@ui-components/neo.tax';
import React from 'react';

import { CheckboxFormType } from './forms.types';

export const CheckboxForm = ({ form }: { form: CheckboxFormType }): React.ReactElement | null => (
  <Stack direction="column" space={4}>
    <Stack direction="row" alignItems="start" justifyContent="start">
      <CheckboxContainer>
        {form.options?.map(({ icon, id, name, subtitle, title }) => (
          <Checkbox
            key={name}
            id={id ? id : `${name}-checkbox-${form.id}`}
            name={name}
            title={title}
            subtitle={subtitle}
            icon={icon}
            disabled={form.disabled}
            checked={form.value.has(name)}
            onChange={(enabled: boolean): void => {
              const newValue = form.value;
              if (enabled) {
                newValue.add(name);
              } else {
                newValue.delete(name);
              }
              form.onChange(newValue);
            }}
          />
        ))}
      </CheckboxContainer>
    </Stack>
    {form.trailingButton}
  </Stack>
);
